/** @license
 * RequireJS plugin for loading JSON files
 * - depends on Text plugin and it was HEAVILY "inspired" by it as well.
 * Author: Miller Medeiros
 * Version: 0.4.0 (2014/04/10)
 * Released under the MIT license
 */
/* eslint-disable max-len */
define('json',['text'], function (text) {
    'use strict';

    var CACHE_BUST_QUERY_PARAM = 'bust';
    var CACHE_BUST_FLAG = '!bust';
    var jsonParse = JSON.parse;
    var buildMap = {};

    function cacheBust(url) {
        var bustUrl = url.replace(CACHE_BUST_FLAG, '');
        bustUrl += (bustUrl.indexOf('?') < 0) ? '?' : '&';
        return bustUrl + CACHE_BUST_QUERY_PARAM + '=' + Math.round(2147483647 * Math.random());
    }

    return {
        load: function (name, req, onLoad, config) {
            if ((config.isBuild && (config.inlineJSON === false || name.indexOf(CACHE_BUST_QUERY_PARAM + '=') !== -1)) || (req.toUrl(name).indexOf('empty:') === 0)) {
                //avoid inlining cache busted JSON or if inlineJSON:false
                //and don't inline files marked as empty!
                onLoad(null);
            } else {
                text.get(req.toUrl(name), function (data) {
                    var parsed;
                    if (config.isBuild) {
                        buildMap[name] = data;
                        onLoad(data);
                    } else {
                        try {
                            parsed = jsonParse(data);
                        } catch (e) {
                            onLoad.error(e);
                        }
                        onLoad(parsed);
                    }
                },
                onLoad.error, {
                    accept: 'application/json'
                });
            }
        },
        normalize: function (name, normalize) {
            // used normalize to avoid caching references to a "cache busted" request
            if (name.indexOf(CACHE_BUST_FLAG) !== -1) {
                return normalize(cacheBust(name));
            }
            // resolve any relative paths
            return normalize(name);
        },
        //write method based on RequireJS official text plugin by James Burke
        //https://github.com/jrburke/requirejs/blob/master/text.js
        write: function (pluginName, moduleName, write) {
            if (moduleName in buildMap) {
                var content = buildMap[moduleName];
                write('define("' + pluginName + '!' + moduleName + '", function(){ return ' + content + ';});\n');
            }
        }
    };
});
